import { useState } from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import { useStaff, useStore } from 'hooks/useSession'
import InfoStoreModal from '@user/staff/modals/InfoStore/InfoStoreModal'

export default function InfoStoreSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const [open, setOpen] = useState(false)
  const { t } = useTranslation(['ui', 'staff', 'countries'])
  const text = 'staff:panel.sections.welcome'

  const store = useStore()
  const staff = useStaff()

  const onPress = () => setOpen(true)

  const staffName = staff?.name || ''
  const staffFirstName = staffName.split(' ')[0]

  const storeName = store?.name || ''
  const storeRef = store?.ref || ''
  const { street, street2, zip, city, country } = store?.address || {}

  const countryName = country
    ? t(`countries:${country.toLowerCase()}`)
    : undefined

  const title = staffName
    ? t(`${text}.title`, { name: staffFirstName })
    : t('ui:stage.staff')

  const staffInfo = `${staffName}`

  const storeInfo = `${storeName} ${storeRef ? `• ${storeRef}` : ''}`

  const addressInfo = [[street, street2].join(' '), [zip, city].join(' ')].join(
    ', '
  )

  const countryInfo = [countryName, country].join(' ')

  const desc = [staffInfo, storeInfo, addressInfo, countryInfo].join('\n')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="large"
          title={title}
          desc={desc}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/staff-welcome.png'),
            imageWrapperStyle: {
              width: '140%',
              height: '140%',
              transformOrigin: 'bottom right',
              // transform: [{ rotateZ: '180deg' }],
            },
            imageStyle: {
              transform: [
                { translateX: Platform.select({ default: 25, web: -25 }) },
                { translateY: 125 },
              ],
            },
            blurStyle: {
              opacity: 0.5,
              transform: [
                { translateX: Platform.select({ default: -50, web: -75 }) },
                { translateY: -100 },
                { scale: 1.5 },
              ],
            },
          }}
        />
      </Pressable>
      <InfoStoreModal open={open} close={() => setOpen(false)} />
    </>
  )
}
